<div
  class="h-100 position-fixed top-0 w-100 d-flex align-items-center justify-content-center flex-column module-loader"
  #moduleloader
>
  <i class="bi" [ngClass]="LoadingDetails?.icon"></i>
  <h1>{{ LoadingDetails?.label }} <span class="dots"></span></h1>
</div>
